import {
  Component,
  Input,
} from '@angular/core';

type ReportFiles = {
  date: Date | String;
  key: string;
  values?: Array<{
    date: Date | String;
    key: string;
    link: string;
    reportType: string;
    click?: () => void;
  }>;
};

@Component({
    selector: 'app-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    standalone: false
})
export class AccordionComponent {
  @Input() reportFiles: ReportFiles[] = [];

  active = {};

  toggle(key) {
    console.log('reportFiles', key);
    this.active = {
      ...this.active,
      [key]: !this.active[key],
    };
  }
}
